import { render, staticRenderFns } from "./FtaInfoMap.vue?vue&type=template&id=b2e2fbf2&scoped=true"
import script from "./FtaInfoMap.vue?vue&type=script&lang=js"
export * from "./FtaInfoMap.vue?vue&type=script&lang=js"
import style0 from "./FtaInfoMap.vue?vue&type=style&index=0&id=b2e2fbf2&prod&scoped=true&lang=css"
import style1 from "./FtaInfoMap.vue?vue&type=style&index=1&id=b2e2fbf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e2fbf2",
  null
  
)

export default component.exports